export default "__VITE_ASSET__Bz3tOu74__"